<template>
  <transition name="fade">
    <AuthTemplate class="password-recovery">
      <template slot="heading">
        {{$t('auth.rec.Forgot your password?')}}
      </template>
      <template slot="heading-follower">
        <div class="mb-4 password-recovery__text">
          {{$t('auth.Please enter your phone number, that was used for your account. You will recieve sms to this phone number.')}}
        </div>
      </template>
      <template slot="form">
        <form
          @submit.prevent="sendRecoveryPhone"
          @keydown.enter="sendRecoveryPhone"
        >
          <TInput
            v-model="formData.phone"
            v-validate="{
              required: true,
              regex: regex.phoneRegex,
            }"
            v-mask="$options.phoneMask"
            :error-messages="errors.collect('phone')"
            type="tel"
            name="phone"
            :label="$t('Phone number')"
            placeholder="+7 (000) 000-00-00"
            :disabled="isLoading"
            class="password-recovery__input"
            :class="{'mb-1': !serverError}"
          />
          <div
            v-if="serverError"
            class="mb-3 error-text"
          >
            {{serverError}}
          </div>
          <TButton
            :loading="isLoading"
            type="submit"
            class="mb-3 password-recovery__button"
          >
            {{$t('auth.rec.Submit')}}
          </TButton>
          <TLink
            route="/login"
            has-icon
            :is-underlined="false"
            class="mb-4 password-recovery__link"
          >
            {{$t('auth.Back to Login')}}
          </TLink>
        </form>
      </template>
    </AuthTemplate>
  </transition>
</template>

<script>
// Utils
import { regex, unmaskValue } from '~/assets/js/utils';

// Mixins
import formMixin from '~/assets/js/mixins/formMixin';

// Models
import passwordRecoveryModel from './models/passwordRecovery';

// Components
import AuthTemplate from './AuthTemplate';

export default {
  name: 'PasswordRecovery',

  components: {
    AuthTemplate,
  },

  mixins: [
    formMixin,
  ],

  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },

    phoneErrors: {
      type: [Error, Object],
      default: null,
    },

    userSavedPhone: {
      type: String,
      default: '',
    },

    serverError: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    regex,
    formData: passwordRecoveryModel(),
  }),

  watch: {
    phoneErrors: {
      handler(errors) {
        this.addErrors(errors);
      },
      deep: true,
    },
  },

  mounted() {
    if (this.userSavedPhone) {
      this.formData.phone = this.userSavedPhone;
      this.$nextTick(() => {
        this.formData.phone = `${this.formData.phone} `;
      });
    }
  },

  methods: {
    unmaskValue,

    async sendRecoveryPhone() {
      const isValid = await this.validateForm();

      if (!isValid) return;

      const params = {
        phone: this.unmaskValue(this.formData.phone),
      };

      this.$emit('send-recovery-phone', params);
    },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/_variables';

.password-recovery {
  &__link {
    display: block;
    text-align: center;
    font-size: 1.3rem;
    line-height: 1.3;
  }
}
</style>
